// assets
import { IconBuildingStore, IconUserCircle, IconBoxSeam, IconTableOptions } from '@tabler/icons';

// constant
const icons = {
  IconBoxSeam,
  IconBuildingStore,
  IconUserCircle,
  IconTableOptions
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const management = {
  id: 'management',
  title: ' ',
  // title: 'Management',
  type: 'group',
  children: [
    {
      id: 'ads',
      title: 'Ads',
      type: 'item',
      url: '/ads',
      icon: icons.IconBoxSeam,
      breadcrumbs: false,
      permission: 2
    },
    {
      id: 'ad_types',
      title: 'Type of ads',
      type: 'item',
      url: '/adtypes',
      icon: icons.IconTableOptions,
      breadcrumbs: false,
      permission: 1
    },
    {
      id: 'airports',
      title: 'Airports',
      type: 'item',
      url: '/airports',
      icon: icons.IconBuildingStore,
      breadcrumbs: false,
      permission: 0
    },
    {
      id: 'users',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: icons.IconUserCircle,
      breadcrumbs: false,
      permission: 0
    }
  ]
};

export default management;
